import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-footer-onboarding',
  templateUrl: './footer-onboarding.component.html',
  styleUrls: ['./footer-onboarding.component.scss'],
})

/**
 * Onboarding footer
 */
export class FooterOnboardingComponent {
  @Input() privacyPolicyLink?: string;
  @Input() termsAndConditionsLink?: string;
}
